export default "/mf-network/487e79d4f18e6a627679741e52713485.svg";